import Home from "./views/Home";

function App() {


  return (

    <div className="box-border px-0 py-0 mx-0 my-0">
      <Home />
    </div>
  );
}

export default App;
